'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _slicedToArray = require('@babel/runtime/helpers/slicedToArray');
var react = require('react');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var _slicedToArray__default = /*#__PURE__*/_interopDefault(_slicedToArray);

/**
 * Custom hook that provides a default state if one isn't passed in. This is helpful in form
 * components that should have the option to have state passed in from a parent.
 *
 * @param {*} value The value for the state variable. This will be used as the default for internal state if setValue isn't passed in
 * @param {*} setValue The setter for value
 *
 * @example
 * // using internal state
 * const [value, setValue] = useDefaultInternalState();
 * @example
 * // using provided state from parent
 * const [value1, setValue1] = useState();
 * const [value2, setValue2] = useDefaultInternalState(value1, setValue1);
 * // value1 === value2 and setValue1 === setValue2
 * @returns {Array} Array of provided state if value and setValue are passed in as parameters. Array of internal state otherwise.
 */
var useDefaultInternalState = function useDefaultInternalState(value, setValue) {
  var _useState = react.useState(value),
    _useState2 = _slicedToArray__default.default(_useState, 2),
    internalValue = _useState2[0],
    setInternalValue = _useState2[1];
  return setValue ? [value, setValue] : [internalValue, setInternalValue];
};
var useDefaultInternalState$1 = useDefaultInternalState;

exports.default = useDefaultInternalState$1;
//# sourceMappingURL=useDefaultInternalState.js.map
